<template>
  <header
    class="header header--3"
    :class="{
      'position-absolute': $route.path === '/' || $route.path === '/home',
    }"
  >
    <div class="container">
      <div class="navbar navbar-expand-lg flex-lg-column d-none d-lg-flex">
        <navbar-logo></navbar-logo>
        <div class="d-flex align-items-center justify-content-between w-100">
          <div>
            <main-nav v-if="isPortalTypeBooks !== null"></main-nav>
          </div>
          <div class="menu">
            <ProfileLink />
            <LoginBtn />
          </div>
        </div>
      </div>

      <div class="navbar d-flex d-lg-none">
        <navbar-logo></navbar-logo>
        <button
          class=""
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasMenu"
          aria-controls="offcanvasMenu"
        >
          <svg width="24" height="24">
            <use href="/static/images/sprite/sprite.svg#burger"></use>
          </svg>
        </button>
      </div>

      <div
        class="offcanvas-menu offcanvas offcanvas-end"
        tabindex="-1"
        id="offcanvasMenu"
      >
        <div class="offcanvas-menu__header d-flex justify-content-end">
          <button
            type="button"
            class="offcanvas-menu__header_btn"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <svg width="36" height="36">
              <use href="/static/images/sprite/sprite.svg#close"></use>
            </svg>
          </button>
        </div>
        <div class="offcanvas-menu__body">
          <main-nav v-if="isPortalTypeBooks !== null"></main-nav>
          <ProfileLink />
          <login-btn></login-btn>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { useEnabledStore } from "@/stores";
import NavbarLogo from "./parts/NavbarLogo.vue";
import MainNav from "./parts/MainNav.vue";
import LoginBtn from "./parts/LoginBtn.vue";
import ProfileLink from "./parts/ProfileLink.vue";

export default {
  components: {
    NavbarLogo,
    MainNav,
    LoginBtn,
    ProfileLink,
  },
  data() {
    return {
      enabledStore: useEnabledStore(),
    };
  },
  computed: {
    isPortalTypeBooks() {
      return this.enabledStore.isPortalTypeBooks;
    },
  },
};
</script>

<style lang="scss">
.header--3 {
  &.header {
    top: 0;
    left: 0;
    right: 0;
    .navbar {
      padding: 20px 0 0;

      @media (min-width: $breakpoint_lg) {
        padding: 40px 0 20px;
        border-bottom: 1px solid $accent_bg_dark;
      }
    }
    .navbar__logo {
      @media (min-width: $breakpoint_lg) {
        margin-bottom: 20px;
      }
    }
    .menu {
      display: flex;
      gap: 40px;
    }
    .menu__item,
    .login-btn,
    .login-btn button,
    .profile-link a {
      position: relative;
      @include font-height(14, 18);
      text-transform: uppercase;
      color: $accent_bg_light;

      &:hover,
      &:focus-visible {
        color: $accent_color;
      }

      &.active {
        color: $accent_color;
        &:after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: -4px;
          height: 1px;
          background-color: $accent_color;
          @media (min-width: $breakpoint_lg) {
            bottom: -21px;
          }
        }
      }
    }
    .offcanvas-menu.offcanvas {
      padding: 0 12px;
      background-color: $accent_bg_dark;

      .offcanvas-menu__body {
        padding: 24px 0;
      }
      .menu {
        flex-direction: column;
        gap: 24px;
      }

      .login-btn,
      .profile-link {
        margin: 24px 0 0;
      }
    }
  }
}
</style>
